// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zdbk","textarea":"styles_textarea__20aN9"};